import React, { useState,useEffect } from 'react';
import axios from "axios";
import { Select } from 'antd';


export default function MenuSupport(props) {

    // const [count, setCount] = useState(0);
    var all_url = window.location.hash;

    var imba_id = all_url.split('/');
    imba_id = imba_id[1];

    const [status, setStateStatus] = useState('');
    const [changestatus, setChangeStatus] = useState(true);

    
   useEffect( () => {
        axios.get('https://api.imbachat.com/imbachat/v2/'+imba_id+'/imbasupport-status', {
            headers: {
                //"Access-Control-Allow-Origin": "*",
                //"Access-Control-Allow-Methods": "POST, GET, PUT, DELETE, OPTIONS",
                //"Access-Control-Allow-Headers": "*",
            },
        }).then(res => {
            res = res.data['support_mode'];
            if(res=="") res="online"
            setStateStatus(res);
        });
    }, []);
   useEffect( () => {
    
    console.log(`${status} 18.01.2024 15:05`);
    
    axios.get('https://edns.ip-api.com/json', {
    },{
        headers: {
        }
    }).then(function(res) {
        console.log(`${res.data.dns.ip} ваш ip`)
        console.log(`${res.data.dns.geo} ваш провайдер`)
      })
    // код определения локального IP-адреса пользователя из статьи с https://blog.ivru.net/?id=157
    //if(window.imbaChat) window.imbaChat.updateContactList()
    //if(window.imbaChat) window.imbaChat.updateContactList()
    }, [status]);
    

    
    const handleChange = (value) => {
        console.log(`selected ${value}`);
        let url = `https://api.imbachat.com/imbasupport/v1/`+imba_id+`/set/imbasupport-status`;
        /*await axios.options(url, {
        },{
            headers: {
                //"Access-Control-Allow-Origin": "*",
               // "Access-Control-Allow-Methods": "POST, GET, PUT, DELETE, OPTIONS",
               // "Access-Control-Allow-Headers": "*",
            }
        });*/
       axios.post(url, {
            'status': value
        },{
            headers: {
                //"Access-Control-Allow-Origin": "*",
                //"Access-Control-Allow-Methods": "POST, GET, PUT, DELETE, OPTIONS",
                //"Access-Control-Allow-Headers": "*",
            }
        }).then(function(res) {
            setStateStatus(value);
            //window.imbaChat.updateContactList()
            //window.imbaChat.updateContactList()
          })
          .catch(function(error) {
            // error response flow
          });
    };

    


    return(
        <div>
            <div >
                <h1>Status: <span id="status_name" style={{'color':'red'}}>{status}</span> </h1>
                <div >
                    <h1 >Select another status:</h1>
                    <Select
                    defaultValue="select status"
                    style={{
                        width: 120,
                    }}
                    onChange={handleChange}
                    options={[
                        {
                        value: 'offline',
                        label: 'offline',
                        },
                        {
                        value: 'online',
                        label: 'online',
                        }
                    ]}
                    />
                </div>
            </div>
        </div>
    );
    /*return(
        <>

        </>
    );*/
}